// Sirve para comparar strings con alfabeto en castellano
// uso: miArray.sort((a, b) => constants.collator.compare(a.CAMPO_STRING, b.CAMPO_STRING))
export const comparadorString = new Intl.Collator('es', { sensitivity: 'base' })

export function removeTildes(texto) {
  return texto?.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}
